module.exports = __webpack_public_path__ + "img/arrow-down.849bce3e.svg";